// assets
import { IconEqual, IconEqualNot, IconBusinessplan } from '@tabler/icons';
import ScaleIcon from '@mui/icons-material/Scale';
import ListIcon from '@mui/icons-material/List';
import CompareArrowsIcon from '@mui/icons-material/CompareArrows';
import StorefrontIcon from '@mui/icons-material/Storefront';

// constant
const icons = {
    IconEqual,
    IconBusinessplan,
    IconEqualNot,
    ScaleIcon,
    ListIcon,
    CompareArrowsIcon,
    StorefrontIcon
};

// ==============================|| EXTRA PAGES MENU ITEMS ||============================== //

const opciones = {
    id: 'opciones',
    title: 'Opciones',
    type: 'group',
    children: [
        {
            id: 'feathomo',
            title: 'Homologaciones',
            type: 'collapse',
            icon: icons.CompareArrowsIcon,
            children: [
                {
                    id: 'homologados',
                    title: 'Homologados',
                    type: 'item',
                    url: '/homologaciones/homologados',
                    target: false,
                    icon: icons.ListIcon
                },
                {
                    id: 'nohomologados',
                    title: 'No homologados',
                    type: 'item',
                    url: '/homologaciones/no-homologados',
                    target: false,
                    icon: icons.IconEqualNot
                },
            ]
        },
        {
            id: 'MaestroProductos',
            title: 'Maestro Productos',
            type: 'item',
            url: '/maestros/productos',
            target: false,
            icon: icons.StorefrontIcon
        },
        {
            id: 'MaestroPrecioZona',
            title: 'Maestro Precio Zona',
            type: 'item',
            url: '/maestros/preciozona',
            target: false,
            icon: icons.ScaleIcon
        }
    ]
};


export default opciones;
